export default __webpack_public_path__ + "static/media/logo-NIH.9bac1486.svg";